<template>
  <div class="EnterpriseUserDesktop">
    <div class="content">
      <div class="left">
        <div>
          <span style="margin-top: -24px; color: #ff1824">(推荐使用)</span>
          <h1 class="title">预存招聘</h1>

          <button class="download" @click="d()">
            <svg
              t="1748069335109"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="3839"
              width="24"
              height="24"
            >
              <path
                d="M0 147.157333L416 89.6v403.242667H0m467.157333-409.685334L1024 0v486.4H467.157333M0 537.6h416v403.242667L0 883.157333M467.157333 537.6H1024V1024l-550.4-76.842667"
                fill="#ffffff"
                p-id="3840"
              ></path>
            </svg>
            Windows下载
          </button>

          <p style="margin-top: 24px">招到人再结算</p>
          <p style="margin-top: 5px">招不到能赚钱</p>
          <p style="margin-top: 5px">不用雇佣招聘人员</p>
          <p style="margin-top: 5px">就能招到人</p>
        </div>

        <div style="margin-left: 100px">
          <span style="margin-top: -24px; color: #ff1824">(招聘方登录)</span>
          <h1 class="title">播聘pc端</h1>
          <button
            class="download"
            onclick="window.location.href='https://bopin.oss-cn-shenzhen.aliyuncs.com/darwin_company/%E6%92%AD%E8%81%98PC%E7%AB%AF%20Setup%201.0.10.exe'"
          >
            <svg
              t="1748069335109"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="3839"
              width="24"
              height="24"
            >
              <path
                d="M0 147.157333L416 89.6v403.242667H0m467.157333-409.685334L1024 0v486.4H467.157333M0 537.6h416v403.242667L0 883.157333M467.157333 537.6H1024V1024l-550.4-76.842667"
                fill="#ffffff"
                p-id="3840"
              ></path>
            </svg>
            Windows下载
          </button>

          <p style="margin-top: 24px">短视频高效招聘</p>
          <p style="margin-top: 5px">低成本高转换</p>
          <p style="margin-top: 5px">精准匹配</p>
        </div>
      </div>
      <div class="right">
        <div class="block">
          <el-carousel
            class="swiper"
            height="586px"
            direction="vertical"
            :autoplay="true"
            :interval="5000"
          >
            <el-carousel-item>
              <div style="padding: 50px">
                <img
                  src="../../../static/qiuzhijiuye/yingyong.png"
                  class="block-img"
                  width="867px"
                  height="486px"
                />
              </div>
            </el-carousel-item>
            <el-carousel-item>
              <div style="padding: 50px">
                <div class="block-item">
                  <img src="../../../static/qiuzhijiuye/zhaop.png" />
                  <div class="block-item-p">
                    <p class="blod">高效招聘, 刷到即招</p>
                    <p>
                      别再翻千篇一律的简历了！15秒短视频，让你看到候选人的真实实力
                    </p>
                  </div>
                </div>
                <div class="block-item">
                  <img src="../../../static/qiuzhijiuye/pipei.png" />
                  <div class="block-item-p">
                    <p class="blod">精准匹配</p>
                    <p>
                      文字简历会“美颜”，短视频才能看到真实力！一键筛出对的人
                    </p>
                  </div>
                </div>
                <div class="block-item">
                  <img src="../../../static/qiuzhijiuye/ai.png" />
                  <div class="block-item-p">
                    <p class="blod">AI数据驱动</p>
                    <p>
                      传统招聘靠猜，短视频招聘靠数据！播放量、互动率、技能展示
                    </p>
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EnterpriseUserDesktop",
  data() {
    return {};
  },
  methods: {
    d() {
      this.$prompt(
        "本链接专属与我方已经签约的客户方可下载，请联系专属客户服务经理。打电话获取下载密码。",
        "提示",
        {
          confirmButtonText: "确定",
          inputType: "password",
        }
      ).then(({ value }) => {
        if (value != "abopin1666") {
          this.$message({
            message: "密码错误",
            type: "error",
          });
          return;
        }

        const link = document.createElement("a");

        // 判断系统环境是mac 还是windows
        if (navigator.userAgent.indexOf("Mac OS X") != -1) {
          link.href =
            "https://bopin.oss-cn-shenzhen.aliyuncs.com/win_en/%E9%A2%84%E5%AD%98%E6%8B%9B%E8%81%98-1.0.2.dmg";
          link.download = "预存招聘";
        } else {
          link.href =
            "https://bopin.oss-cn-shenzhen.aliyuncs.com/darwin_en/%E9%A2%84%E5%AD%98%E6%8B%9B%E8%81%98%20Setup%201.1.0.exe";
        }

        link.download = "预存招聘";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
  },
  mounted() {
    // 保持swiper居中在block 保持居中
    document.querySelector(".swiper").style.marginTop =
      (window.innerHeight - 760) / 2 + "px";

    document.querySelector(
      ".el-carousel__indicator--vertical .el-carousel__button"
    ).style.width = "5px";
    document.querySelector(
      ".el-carousel__indicator--vertical .el-carousel__button"
    ).style.height = "30px";
  },
};
</script>

<style scoped="scoped">
@import url("./index.css");
</style>



// WEBPACK FOOTER //
// src/pages/enterprise-user-desktop/index.vue